import React, { useState, useEffect, useMemo } from 'react';
import TR from './../../Trans';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import muvikaAttrs from './../../attrs'
import { checkIfMobile } from '../../services/screen';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import IntervalService from './../../services/intervals';
import BackgroundMusicPeekListItem from './BackgroundMusicPeekListItem';
import TrackAlreadyQueue from '../dialogs/TrackAlreadyQueue';
import MuvikaService from './../../services/muvika';
import Collapse from '@mui/material/Collapse';
import { useMediaQuery } from 'react-responsive';
import List from '@mui/material/List';
import BackgroundMusicEditPlayListPerformance from '../dialogs/BackgroundMusicEditPlayListPerformance';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import RepeatIcon from '@mui/icons-material/Repeat';
import AlbumIcon from '@mui/icons-material/Album';
import ListItemIcon from '@mui/material/ListItemIcon';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import BackgroundMusicChangeTrackPerformance from '../dialogs/BackgroundMusicChangeTrackPerformance';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import accountStore from '../../stores/account';
import bgPerformanceStore from '../../stores/bgPerformance';
import playerStore from '../../stores/player';
import messageStore from './../../stores/message';
import favoritesStore from '../../stores/favorites';
import navigationStore from '../../stores/navigation';
import musicPlayerStore from '../../stores/musicPlayer';

function BackgroundPlayListListItem(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const settings = settingsStore((state) => state.settings);
  const movePerformanceInPlayList = bgPerformanceStore((state) => state.movePerformanceInPlayList);

  const [open, setOpen] = useState(props.open);
  const [isEditPerformanceOpen, setIsEditPerformanceOpen] = useState(false);
  const [chosenPerformance, setChosenPerformance] = useState(null);
  const [isChangeTrackPerformanceOpen, setIsChangeTrackPerformanceOpen] = useState(false);
  const [chosenTrack, setChosenTrack] = useState({});
  const [isTrackAlreadyQueueOpen, setIsTrackAlreadyQueueOpen] = useState(false);
  const [chosenPlayList, setChosenPlayList] = useState(null);
  const [chosenPosition, setChosenPosition] = useState(null);

  const timeDiff = accountStore((state) => state.timeDiff);
  const setError = messageStore((state) => state.setError);
  const performanceToBeChanged = bgPerformanceStore((state) => state.performanceToBeChanged);
  const changeTrackPerformance = bgPerformanceStore((state) => state.changeTrackPerformance);
  const addPerformanceToPlayQueue = bgPerformanceStore((state) => state.addPerformanceToPlayQueue);
  const addPerformanceToPlayList = bgPerformanceStore((state) => state.addPerformanceToPlayList);
  const editPerformanceInPlayList = bgPerformanceStore((state) => state.editPerformanceInPlayList);
  const isPlaying = musicPlayerStore((state) => state.isPlaying);
  const singers = singersStore((state) => state.singers);
  const playQueue = bgPerformanceStore((state) => state.playQueue);
  const playLists = bgPerformanceStore((state) => state.playLists);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);

  const handleOpenTrackAlreadyQueue = (track) => {
    setIsTrackAlreadyQueueOpen(true);
  };

  const handleCloseTrackAlreadyQueue = () => {
    setIsTrackAlreadyQueueOpen(false);
    props.onEditPerformanceClose();
  };

  const handleConfirmDoubleTrack = () => {
    if (chosenPlayList) {
      console.log("chosenPosition", chosenPosition)
      addPerformanceToPlayList(sessionToken, chosenPerformance.track, singers[0], chosenPlayList.id, chosenPosition);
    }
    handleCloseTrackAlreadyQueue();
  };

  const [isPlayingNow, setPlayingNow] = useState(false);

  const handleOpenEditPerformance = (performance, playNow = false) => {
    if (performance) {
      setPlayingNow(playNow);
      performance.track.last_singer_id = performance.profile.id;
      setChosenPerformance(performance);
      setIsEditPerformanceOpen(true);
    }
  };

  const handleCloseEditPerformance = () => {
    setIsEditPerformanceOpen(false);
    props.onEditPerformanceClose();
  };

  const handleOpenChangePerformance = (track) => {
    if (performanceToBeChanged) {
      setChosenTrack(track);
      setIsChangeTrackPerformanceOpen(true);
    }
  };

  const handleChangeTrackPerformance = () => {
    changeTrackPerformance(sessionToken, chosenTrack, singers[0]);
    setIsChangeTrackPerformanceOpen(false);
    props.onEditPerformanceClose();
  };

  const handleCloseChangeTrackPerformance = () => {
    setIsChangeTrackPerformanceOpen(false);
    props.onEditPerformanceClose();
  };

  const handleEditPerformance = (performanceId, playList, toPos, playNow) => {
    if (playList) {
      if (playList.id === props.playList.id) {
        console.log("editPerformanceInPlayList", toPos);
        editPerformanceInPlayList(sessionToken, performanceId, singers[0], playList.id, toPos);
        setIsEditPerformanceOpen(false);
      } else {
        let isAlreadyOnPlayList = false;
        for (var i = 0; i < playList.items.length; i++) {
          let track = playList.items[i].track;
          if (track.track_id === chosenPerformance.track.track_id) {
            isAlreadyOnPlayList = true;
            break;
          }
        }
        if (isAlreadyOnPlayList) {
          setChosenPlayList(playList);
          setChosenPosition(toPos);
          handleOpenTrackAlreadyQueue();
        } else {
          setChosenPlayList(null);
          addPerformanceToPlayList(sessionToken, chosenPerformance.track, singers[0], playList.id, toPos);
        }
      }
    } else {
      addPerformanceToPlayQueue(sessionToken, chosenPerformance.track, singers[0], toPos, false, playNow);
    }
    if (playNow) {
      setMobilePlayerVisible(true);
    }
    setIsEditPerformanceOpen(false);
    props.onEditPerformanceClose();
  };

  const handleClick = (e) => {
    e.stopPropagation();
    let openPlayListsJSON = sessionStorage.getItem(muvikaAttrs.service+"-music-playlists-opened") || "[]";
    let openPlayLists = JSON.parse(openPlayListsJSON);
    if (!open) {
      openPlayLists.push(props.playList.id);
      sessionStorage.setItem(muvikaAttrs.service+"-music-playlists-opened", JSON.stringify(openPlayLists));
    } else {
      const index = openPlayLists.indexOf(props.playList.id);
      if (index > -1) {
        openPlayLists.splice(index, 1);
      }
      sessionStorage.setItem(muvikaAttrs.service+"-music-playlists-opened", JSON.stringify(openPlayLists));
    }
    setOpen(!open);
  };

  const secondaryText = () => {
    if (props.performances) {
      let date = new Date(props.created);
      date.setMinutes(date.getMinutes() - timeDiff);
      return dayjs(date).format('YYYY-MM-DD') + " (" + props.performances.length + " " + TR.cm_songs + ")";
    }
  };

  const renderEditButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => props.onOpenEditDialog(e)}>
      <EditIcon />
    </IconButton>;
  };

  const renderPlayButton = () => {
    return <IconButton disabled={props.playList.items.length == 0} color="white" component="label" size="large" onClick={(e) => props.onSetCurrentPlayList(e)}>
      <PlayArrowIcon />
    </IconButton>;
  };

  const renderRepeatButton = () => {
    return <IconButton disabled={props.playList.items.length == 0} color={props.isRepeatPlayList ? "primary" : "white"} component="label" size="large" onClick={(e) => props.onRepeat(e)}>
      <RepeatIcon />
    </IconButton>;
  };

  const renderDeleteButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => props.onOpenDeleteDialog(e)}>
      <DeleteIcon />
    </IconButton>;
  };

  const buttons = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <div>
          {renderPlayButton()}
          {renderRepeatButton()}
          {renderEditButton()}
          {renderDeleteButton()}
        </div>;
      }
    }
  };

  const handleDragEnd = (result) => {
    if (result.destination) {
      let source = result.source.index;
      let dest = result.destination.index;
      if (source != dest) {
        movePerformanceInPlayList(sessionToken, props.playList.id, source, dest);
      }
    }
  };

  const performanceIds = useMemo(() => {
    return props.playList?.items?.map((p) => p.unique_id);
  }, [props.playList]);

  const performancesNonDraggable = useMemo(() => {
    if (performanceIds) {
      if (performanceIds.length > 0) {
        console.log("render again");
        return performanceIds.map((performanceId, index) => {
          return <BackgroundMusicPeekListItem
            key={performanceId}
            draggableId={"music-playlist-" + props.id + "-" + performanceId}
            index={index}
            count={performanceIds.length}
            playListId={props.id}
            performanceId={performanceId}
            onMenuClose={() => {
              props.onEditPerformanceClose();
            }}
            onPlayNow={() => {
              handleOpenEditPerformance(performance, true);
            }}
            onEditPerformance={() => {
              handleOpenEditPerformance(performance);
            }}
            onChangeTrackPerformance={(e) => {
              e.preventDefault();
              handleOpenChangePerformance(performance.track);
            }}
          />;
        });
      }
    }
    return <span>{TR.cm_playlist_is_empty}</span>;
  }, [performanceIds]);

  const performances = useMemo(() => {
    if (performanceIds) {
      if (performanceIds.length > 0) {
        console.log("render again");
        return performanceIds.map((performanceId, index) => {
          return <BackgroundMusicPeekListItem
            key={performanceId}
            draggableId={"music-playlist-" + props.id + "-" + performanceId}
            index={index}
            count={performanceIds.length}
            playListId={props.id}
            performanceId={performanceId}
            onMenuClose={() => {
              props.onEditPerformanceClose();
            }}
            onPlayNow={(performance) => {
              handleOpenEditPerformance(performance, true);
            }}
            onEditPerformance={(performance) => {
              handleOpenEditPerformance(performance);
            }}
            onChangeTrackPerformance={(e, performance) => {
              e.preventDefault();
              handleOpenChangePerformance(performance.track);
            }}
          />;
        });
      }
    }
    return <span>{TR.cm_playlist_is_empty}</span>;
  }, [performanceIds]);

  const editPerformanceDialog = () => {
    if (chosenPerformance) {
      return <BackgroundMusicEditPlayListPerformance
        open={isEditPerformanceOpen}
        onClose={handleCloseEditPerformance}
        performanceId={chosenPerformance.unique_id}
        performance={chosenPerformance}
        onEditPerformance={handleEditPerformance}
        pitch={chosenPerformance.pitch}
        track={chosenPerformance.track}
        playList={props.playList}
        singers={singers}
        singer={chosenPerformance.profile}
        isPlaying={isPlaying.isPlaying}
        playLists={playLists}
        playQueue={playQueue}
        isPlayingNow={isPlayingNow}
      />;
    }
  };

  const renderChangeTrackDialog = () => {
    if (performanceToBeChanged) {
      return <BackgroundMusicChangeTrackPerformance
        open={isChangeTrackPerformanceOpen}
        onClose={handleCloseChangeTrackPerformance}
        track={chosenTrack}
        performance={performanceToBeChanged}
        onChangeTrackPerformance={handleChangeTrackPerformance}
      />;
    }
  };

  const renderPlayListItems = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId={"droppable-" + props.playList.id}>
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef} >
                <List className="muvika-list-performances" component="div" disablePadding>
                  {performances}
                </List>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>;
      }
    }
    return <List className="muvika-list-performances" component="div" disablePadding>
      {performancesNonDraggable}
    </List>;
  };

  return (
    <div>
      {editPerformanceDialog()}
      {renderChangeTrackDialog()}
      <TrackAlreadyQueue
        open={isTrackAlreadyQueueOpen}
        onClose={handleCloseTrackAlreadyQueue}
        onConfirmation={handleConfirmDoubleTrack}
      />
      <ListItemButton onClick={handleClick}>
        <ListItemText primary={props.name} secondary={secondaryText()} />
        {buttons()}
        <IconButton onClick={handleClick}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {renderPlayListItems()}
      </Collapse>
    </div>
  );
}

export default BackgroundPlayListListItem;